import React from 'react';
import OpportunityListPage from './OpportunityListPage';

export default function ConsultancyPage() {
  return <OpportunityListPage opportunityType="Consultancy_Opportunity" />;
}